<template>
    <div :class="embutido ? 'gch-embutido' : 'gch-container'">
        <div v-if="!embutido" class="gch-header">
            <div class="gch-logo-container">
                <img src="../feiraempreendedor/assets/logo-feira-empreendedor.svg" alt="Feira do Empreendedor 26" class="gch-logo" />
            </div>
        </div>
        <div class="gch-card">
            <h2 class="gch-titulo">Cadastro / Gerar Senha</h2>

            <div v-if="!etiquetaGerada" class="gch-form">
                <div class="gch-row">
                    <div>
                        <label class="gch-label">CPF</label>
                        <InputMask
                            v-model="form.cpf"
                            mask="999.999.999-99"
                            placeholder="CPF"
                            :unmask="true"
                            :autoClear="false"
                            class="gch-input"
                            :class="{ 'p-invalid': v$.form.cpf.$error }"
                            @blur="v$.form.cpf.$touch()"
                        />
                        <small v-if="v$.form.cpf.$error" class="p-error">CPF inválido (11 dígitos).</small>
                    </div>
                    <div>
                        <label class="gch-label">Nome *</label>
                        <InputText
                            v-model="form.nome"
                            placeholder="Nome completo"
                            class="gch-input"
                            :class="{ 'p-invalid': v$.form.nome.$error }"
                            @blur="v$.form.nome.$touch()"
                        />
                        <small v-if="v$.form.nome.$error" class="p-error">Campo obrigatório.</small>
                    </div>
                </div>

                <div class="gch-row mt-3">
                    <div>
                        <label class="gch-label gch-label-pj">CNPJ</label>
                        <InputMask v-model="form.cnpj" mask="99.999.999/9999-99" :unmask="true" :autoClear="false" placeholder="CNPJ" class="gch-input" />
                    </div>
                    <div>
                        <label class="gch-label">WhatsApp</label>
                        <InputMask
                            v-model="form.telefone"
                            mask="(99) 9 9999-9999"
                            :unmask="true"
                            :autoClear="false"
                            placeholder="(00) 0 0000-0000"
                            class="gch-input"
                        />
                    </div>
                </div>

                <div class="gch-row mt-3">
                    <div style="grid-column: 1 / -1">
                        <label class="gch-label">E-mail</label>
                        <InputText v-model="form.email" placeholder="email@exemplo.com" class="gch-input" />
                    </div>
                </div>

                <div class="gch-row-3 mt-3">
                    <div>
                        <label class="gch-label">Espaço *</label>
                        <Dropdown
                            v-model="espacoSelecionado"
                            :options="espacos"
                            optionLabel="nome"
                            placeholder="Selecione o espaço"
                            :disabled="!!codigoEspacoFixo"
                            class="gch-input"
                            :class="{ 'p-invalid': v$.espacoSelecionado.$error }"
                        />
                        <small v-if="v$.espacoSelecionado.$error" class="p-error">Selecione um espaço.</small>
                    </div>
                    <div>
                        <label class="gch-label">Mesa *</label>
                        <Dropdown
                            v-model="mesaSelecionada"
                            :options="mesas"
                            optionLabel="rotulo"
                            placeholder="Selecione a mesa"
                            :disabled="!espacoSelecionado || carregandoMesas"
                            class="gch-input"
                            :class="{ 'p-invalid': v$.mesaSelecionada.$error }"
                        />
                        <small v-if="carregandoMesas" class="text-color-secondary">Carregando mesas...</small>
                        <small v-else-if="espacoSelecionado && mesas.length === 0" class="p-error">Nenhuma mesa cadastrada para esse espaço.</small>
                        <small v-else-if="v$.mesaSelecionada.$error" class="p-error">Selecione uma mesa.</small>
                    </div>
                    <div v-if="!mesaEhEspontanea">
                        <label class="gch-label">Horário *</label>
                        <Dropdown
                            v-model="horarioSelecionado"
                            :options="horariosDisponiveis"
                            placeholder="Selecione um horário"
                            :disabled="!mesaSelecionada || carregandoHorarios"
                            class="gch-input"
                            :class="{ 'p-invalid': v$.horarioSelecionado.$error }"
                        />
                        <small v-if="carregandoHorarios" class="text-color-secondary">Carregando horários...</small>
                        <small v-else-if="mesaSelecionada && horariosDisponiveis.length === 0" class="p-error">Sem horários disponíveis hoje.</small>
                        <small v-else-if="v$.horarioSelecionado.$error" class="p-error">Selecione um horário.</small>
                    </div>
                    <div v-else>
                        <label class="gch-label">Horário</label>
                        <div class="gch-badge-espontanea">Atendimento por ordem de chegada</div>
                    </div>
                </div>

                <div class="mt-5 flex justify-content-end gap-2">
                    <Button label="Limpar" class="p-button-text" @click="limpar" />
                    <Button label="Gerar Senha" :disabled="v$.$invalid || processando" class="gch-btn gch-btn-primary" @click="gerarSenha" />
                </div>
            </div>

            <div v-else class="gch-resultado">
                <div class="gch-etiqueta">
                    <div style="font-size: 1rem; color: var(--gch-roxo); font-weight: 700">SEBRAE / Feira do Empreendedor</div>
                    <div class="gch-etiqueta-senha">{{ etiqueta.senha }}</div>
                    <div class="gch-etiqueta-nome">{{ etiqueta.nome }}</div>
                    <div class="gch-etiqueta-espaco">{{ etiqueta.nomeEspaco }}</div>
                    <div class="gch-etiqueta-espaco" v-if="etiqueta.numeroMesa">Mesa {{ etiqueta.numeroMesa }}</div>
                    <div class="gch-etiqueta-horario" v-if="etiqueta.horario">{{ etiqueta.horario }}</div>
                </div>
                <div class="flex justify-content-center mt-3" style="gap: 1.5rem">
                    <Button label="Imprimir" icon="pi pi-print" class="gch-btn gch-btn-laranja" @click="imprimir" />
                    <Button label="Novo Cadastro" class="gch-btn gch-btn-primary" @click="reiniciar" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, requiredIf } from '@vuelidate/validators';

import services from './services';

export default {
    name: 'FormularioCadastro',

    props: {
        autenticado: {
            type: Boolean,
            default: false,
        },
        codigoEspacoFixo: {
            type: String,
            default: null,
        },
        idEspacoFixo: {
            type: Number,
            default: null,
        },
        embutido: {
            type: Boolean,
            default: false,
        },
    },

    setup() {
        return { v$: useVuelidate() };
    },

    data() {
        return {
            espacos: [],
            espacoSelecionado: null,
            mesas: [],
            mesaSelecionada: null,
            horariosDisponiveis: [],
            carregandoMesas: false,
            carregandoHorarios: false,
            horarioSelecionado: null,
            form: {
                cpf: '',
                nome: '',
                cnpj: '',
                telefone: '',
                email: '',
            },
            etiquetaGerada: false,
            etiqueta: {
                idAtendimento: null,
                senha: '',
                nome: '',
                nomeEspaco: '',
                numeroMesa: '',
                horario: '',
            },
            processando: false,
            imprimindo: false,
        };
    },

    validations() {
        return {
            form: {
                nome: { required },
                cpf: {
                    cpfValido: (value) => !!value && String(value).replace(/\D/g, '').length === 11,
                },
            },
            espacoSelecionado: { required },
            mesaSelecionada: { required },
            horarioSelecionado: { required: requiredIf(() => !this.mesaEhEspontanea) },
        };
    },

    computed: {
        mesaEhEspontanea() {
            return this.mesaSelecionada?.tipo === 'Espontanea';
        },
    },

    mounted() {
        this.carregarEspacos();
    },

    watch: {
        espacoSelecionado(novo) {
            this.mesaSelecionada = null;
            this.horarioSelecionado = null;
            this.horariosDisponiveis = [];
            if (novo) {
                this.carregarMesas(novo.codigo);
            } else {
                this.mesas = [];
            }
        },
        mesaSelecionada(novo) {
            this.horarioSelecionado = null;
            if (novo && novo.tipo === 'Espontanea') {
                this.horariosDisponiveis = [];
            } else if (novo) {
                this.carregarHorariosDaMesa(novo.id);
            } else {
                this.horariosDisponiveis = [];
            }
        },
    },

    methods: {
        dataHojeIso() {
            const d = new Date();
            const ano = d.getFullYear();
            const mes = String(d.getMonth() + 1).padStart(2, '0');
            const dia = String(d.getDate()).padStart(2, '0');
            return `${ano}-${mes}-${dia}T00:00:00`;
        },

        async carregarEspacos() {
            this.$store.dispatch('addRequest');
            try {
                // apenasComMesas=true descarta espacos sem mesa cadastrada (legacy/lixo),
                // evitando que o atendente selecione um espaco sem fluxo configurado.
                const response = await services.obterEspacos({
                    autenticado: this.autenticado,
                    apenasComMesas: true,
                });
                if (response?.success) {
                    this.espacos = response.data || [];
                    if (this.codigoEspacoFixo) {
                        const fixo = this.espacos.find((e) => e.codigo === this.codigoEspacoFixo);
                        if (fixo) {
                            this.espacoSelecionado = fixo;
                        }
                    } else if (this.idEspacoFixo) {
                        const fixo = this.espacos.find((e) => e.id === this.idEspacoFixo);
                        if (fixo) this.espacoSelecionado = fixo;
                    }
                } else {
                    this.notificarErro('Não foi possível carregar os espaços.');
                }
            } finally {
                this.$store.dispatch('removeRequest');
            }
        },

        async carregarMesas(codigoEspaco) {
            if (!codigoEspaco) {
                this.mesas = [];
                return;
            }
            this.carregandoMesas = true;
            this.$store.dispatch('addRequest');
            try {
                const response = await services.obterMesasPorEspaco(codigoEspaco, { autenticado: this.autenticado });
                if (response?.success) {
                    // A planilha da Feira separa cada mesa por consultor; o rotulo concatena
                    // numero + consultor para deixar a escolha clara para o atendente.
                    this.mesas = (response.data || []).map((m) => ({
                        ...m,
                        rotulo: m.consultor ? `Mesa ${m.numero} — ${m.consultor}` : `Mesa ${m.numero}`,
                    }));
                    if (this.mesas.length === 0) {
                        // Mesa cadastrada precisa estar vinculada ao mesmo id_espaco do
                        // espaco selecionado; senao a fila do consultor nao funciona.
                        this.$toast?.add({
                            severity: 'warn',
                            summary: 'Nenhuma mesa encontrada',
                            detail: `Não há mesas cadastradas para o espaço ${codigoEspaco}.`,
                        });
                    }
                } else {
                    this.mesas = [];
                    this.notificarErro(
                        (response?.errors || [`Erro ao carregar mesas (${response?.status || 'sem resposta'}).`])[0],
                    );
                }
            } finally {
                this.carregandoMesas = false;
                this.$store.dispatch('removeRequest');
            }
        },

        async carregarHorariosDaMesa(idMesa) {
            this.carregandoHorarios = true;
            this.$store.dispatch('addRequest');
            try {
                const response = await services.obterHorariosDisponiveisDaMesa(idMesa, this.dataHojeIso(), {
                    autenticado: this.autenticado,
                });
                if (response?.success) {
                    // API ja devolve a lista com flag disponivel; mantemos somente os livres.
                    this.horariosDisponiveis = (response.data || []).filter((h) => h.disponivel).map((h) => h.horario);
                } else {
                    this.horariosDisponiveis = [];
                    this.notificarErro(
                        (response?.errors || [`Erro ao carregar horários (${response?.status || 'sem resposta'}).`])[0],
                    );
                }
            } finally {
                this.carregandoHorarios = false;
                this.$store.dispatch('removeRequest');
            }
        },

        montarDataHoraAgendada() {
            if (!this.horarioSelecionado) return null;
            const [hh, mm] = this.horarioSelecionado.split(':');
            const d = new Date();
            d.setHours(parseInt(hh, 10), parseInt(mm, 10), 0, 0);
            const ano = d.getFullYear();
            const mes = String(d.getMonth() + 1).padStart(2, '0');
            const dia = String(d.getDate()).padStart(2, '0');
            return `${ano}-${mes}-${dia}T${hh}:${mm}:00`;
        },

        async gerarSenha() {
            this.v$.$touch();
            if (this.v$.$invalid) return;
            this.processando = true;
            try {
                const payloadCliente = {
                    cpf: String(this.form.cpf).replace(/\D/g, ''),
                    nome: this.form.nome,
                    telefone: this.form.telefone || null,
                    email: this.form.email || null,
                    cnpj: this.form.cnpj ? String(this.form.cnpj).replace(/\D/g, '') : null,
                };

                this.$store.dispatch('addRequest');
                let respCliente;
                try {
                    respCliente = await services.cadastrarCliente(payloadCliente, { autenticado: this.autenticado });
                } finally {
                    this.$store.dispatch('removeRequest');
                }
                if (!respCliente?.success) {
                    this.notificarErro((respCliente?.errors || ['Erro ao cadastrar cliente.'])[0]);
                    return;
                }

                const idCliente = respCliente.data?.id;
                const payloadAtendimento = {
                    idCliente,
                    idEspaco: this.espacoSelecionado.id,
                    idMesa: this.mesaSelecionada?.id || null,
                    dataHoraAgendada: this.mesaEhEspontanea ? null : this.montarDataHoraAgendada(),
                };

                this.$store.dispatch('addRequest');
                let respAtendimento;
                try {
                    respAtendimento = await services.registrarAtendimento(payloadAtendimento, { autenticado: this.autenticado });
                } finally {
                    this.$store.dispatch('removeRequest');
                }
                if (!respAtendimento?.success) {
                    this.notificarErro((respAtendimento?.errors || ['Erro ao registrar atendimento.'])[0]);
                    return;
                }

                const data = respAtendimento.data;
                this.etiqueta = {
                    idAtendimento: data.id || data.idAtendimento || null,
                    senha: data.senha,
                    nome: this.form.nome,
                    nomeEspaco: data.nomeEspaco || this.espacoSelecionado.nome,
                    numeroMesa: data.numeroMesa || this.mesaSelecionada?.numero || '',
                    horario: this.mesaEhEspontanea ? 'Por ordem de chegada' : this.horarioSelecionado,
                };
                this.etiquetaGerada = true;

                this.$toast?.add({
                    severity: 'success',
                    summary: 'Senha gerada',
                    detail: `Senha ${data.senha} gerada com sucesso!`,
                });

                this.$emit('senha-gerada', { atendimento: data, cliente: respCliente.data });
            } finally {
                this.processando = false;
            }
        },

        printPDF(blob) {
            const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);
            iframe.onload = () => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            };
        },

        async imprimir() {
            if (this.imprimindo) return;
            this.imprimindo = true;
            this.$store.dispatch('addRequest');
            try {
                const payload = {
                    idAtendimento: this.etiqueta.idAtendimento,
                    senha: this.etiqueta.senha,
                    nome: this.etiqueta.nome,
                    nomeEspaco: this.etiqueta.nomeEspaco,
                    horario: this.etiqueta.horario,
                };
                const response = await services.emitirEtiqueta(payload, { autenticado: this.autenticado });
                if (response?.success) {
                    this.printPDF(response.data);
                } else {
                    this.notificarErro((response?.errors || ['Erro ao emitir etiqueta.'])[0]);
                }
            } finally {
                this.imprimindo = false;
                this.$store.dispatch('removeRequest');
            }
        },

        reiniciar() {
            this.etiquetaGerada = false;
            this.etiqueta = { idAtendimento: null, senha: '', nome: '', nomeEspaco: '', numeroMesa: '', horario: '' };
            this.limpar(false);
            // Mantem o espaco/mesa selecionados e apenas recarrega os horarios para o
            // proximo cadastro — agiliza a operacao no balcao.
            if (this.mesaSelecionada && !this.mesaEhEspontanea) {
                this.carregarHorariosDaMesa(this.mesaSelecionada.id);
            }
        },

        limpar(resetEspaco = true) {
            this.form = {
                cpf: '',
                nome: '',
                cnpj: '',
                telefone: '',
                email: '',
            };
            this.horarioSelecionado = null;
            if (resetEspaco && !this.codigoEspacoFixo && !this.idEspacoFixo) {
                this.espacoSelecionado = null;
                this.mesaSelecionada = null;
            }
            this.v$.$reset();
        },

        notificarErro(mensagem) {
            this.$toast?.add({
                severity: 'error',
                summary: 'Erro',
                detail: mensagem || 'Erro ao processar.',
            });
        },
    },
};
</script>

<style src="./guiche.css"></style>
